import moment from "moment/moment";

export const getReturnsMonths = (currentMonth) => {
    const returnsMonths = []
    for (let i = 0, j = 12; i < 12; i++, j--) {
        const previousMonth = subtractMonths(currentMonth, i)
        returnsMonths.push({value: previousMonth.format("MMM-YYYY").toUpperCase(), label:previousMonth.format("MMMM YYYY"), id: j})
    }
    return returnsMonths.sort((a, b) => a.id - b.id)
}

export const subtractMonths = (date, months) => {
    return moment(date).subtract(months, 'months')
}